import React from "react";
import styled from "styled-components";
import shape1 from "../assets/shape1.png";
import shape2 from "../assets/shape2.png";
import shape3 from "../assets/shape3.png";
import useInViewAnimation from "../hooks/useInViewAnimation";
import { motion } from "framer-motion";
function Page3Mobile() {
  const variant1 = (i) => {
    return {
      visible: {
        opacity: 1,
        transition: { duration: 0.7, delay: i * 0.2 },
      },
      hidden: { opacity: 0 },
    };
  };
  const [ref1, control1] = useInViewAnimation(0.7);
  return (
    <MainContainer id="introduction">
      <Title initial="hidden" variants={variant1(0)} animate={control1}>
        왜 주얼리를
        <br />
        생산해야 될까요?
      </Title>
      <Column>
        <Shape initial="hidden" variants={variant1(1)} animate={control1}>
          <ShapeTitle ref={ref1}>합리적인 가격</ShapeTitle>
          <ShapeDesc1>
            주얼리는 어페럴에 비해 생산단가와 판매가가 저렴한 편으로
            고객님들에게 부담스럽지 않은 가격대로 판매 가능합니다
          </ShapeDesc1>
          <ShapeImg src={shape1} />
        </Shape>
        <Shape initial="hidden" variants={variant1(1.3)} animate={control1}>
          <ShapeTitle>브랜드 이미지 고급화</ShapeTitle>
          <ShapeDesc2>
            하이앤드 브랜드에서 매시즌마다 주얼리를 릴리즈하는 이유는 주얼리가
            주는 고급스러운 이미지 때문입니다
          </ShapeDesc2>
          <ShapeImg src={shape2} />
        </Shape>
        <Shape initial="hidden" variants={variant1(1.6)} animate={control1}>
          <ShapeTitle>풍부한 구성</ShapeTitle>
          <ShapeDesc3>주얼리를 통해 시즌의 풍부함을 더해보세요</ShapeDesc3>
          <ShapeImg src={shape3} />
        </Shape>
      </Column>
      <Ellipse2247 />
      <Ellipse2249 />
      <Ellipse2253 />
    </MainContainer>
  );
}

export default Page3Mobile;
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  background: #070707;
  overflow: hidden;
  position: relative;
`;
const Title = styled(motion.p)`
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px; /* 150% */
  margin-top: 70px;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  transform-origin: top center;
  margin-top: 60px;
  margin-bottom: 100px;
`;
const Shape = styled(motion.div)`
  width: 270px;
  height: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ShapeImg = styled.img`
  position: absolute;
  width: 270px;
  height: 270px;
`;
const ShapeTitle = styled.p`
  color: #000;
  text-align: center;
  font-family: Pretendard;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px; /* 145.455% */
  z-index: 10;
  margin-top: 62px;
`;
const ShapeDesc1 = styled.p`
  width: 210px;
  color: #000;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
  z-index: 10;
  word-break: keep-all;
  margin-top: 6px;
`;
const ShapeDesc2 = styled(ShapeDesc1)`
  width: 205px;
  margin-top: 6px;
`;
const ShapeDesc3 = styled(ShapeDesc1)`
  width: 150px;
  margin-top: 20px;
`;
const Ellipse2247 = styled.div`
  position: absolute;
  left: 0;
  width: 405.031px;
  height: 178.789px;
  transform: rotate(-174.711deg);
  flex-shrink: 0;
  border-radius: 405.031px;
  opacity: 0.3;
  background: radial-gradient(
    250.25% 59.88% at 62.51% 47.61%,
    #ff8b3f 0%,
    rgba(255, 139, 63, 0) 100%
  );
  filter: blur(50px);
  transform: translate(-100px, 1130px);
`;
const Ellipse2249 = styled.div`
  position: absolute;
  width: 310px;
  height: 163px;
  flex-shrink: 0;
  border-radius: 310px;
  opacity: 0.45;
  background: radial-gradient(
    55.79% 55.78% at 49.9% 44.22%,
    #ff69ea 0%,
    rgba(255, 105, 234, 0) 100%
  );
  filter: blur(50px);
  transform: translate(0, -69px);
`;
const Ellipse2253 = styled.div`
  position: absolute;
  left: 0;
  width: 217.221px;
  height: 156.056px;
  transform: rotate(-174.711deg);
  flex-shrink: 0;
  background: radial-gradient(
    50% 50% at 50% 50%,
    #ff69ea 0%,
    rgba(255, 105, 234, 0) 100%
  );
  opacity: 0.5;
  mix-blend-mode: screen;
  filter: blur(50px);
  border-radius: 200px;
  transform: translate(-64px, 1050px);
`;
